export interface VuetifyForm extends Vue {
  validate: () => boolean;
  reset: () => boolean;
}

export type LogicType = 'AND' | 'OR' | 'NOT';

// Attachments

// TODO: Aggiungere i relativi permessi nel backend

export type AttachmentType = 'richiestaPreventivo' | 'ordine' | 'preventivo' | 'preventivoRevisionato' | 'ordineRevisionato'
  | 'reportEcobonusCheck' | 'sopralluogoTecnico' | 'esitoSopralluogoTecnico' | 'fotoSopralluogoTecnico' | 'extraSopralluogoTecnico'
  | 'dicoElettrica' | 'dicoTermica' | 'visura' | 'autotest'
  | 'fotoImpianto' | 'allegatiInstallazione' | 'fotoDG' | 'fotoInverter' | 'fotoBatteria'
  | 'titoloAutorizzativo' | 'progettoElettrico'
  | 'progettoTermico' | 'computoMetrico' | 'altri'
  | 'registrazioneCriter' | 'fGas' | 'confUrbCat' | 'modOutFattEner' | 'apePre' | 'apePostSimul' | 'ddt'
  | 'endOfWork' | 'verbaleAllaccio'
  | 'visuraCatastale' | 'ultimaBollettaElettrica' | 'documentiIdentita' | 'unifilare'
  | 'dicoVisuraCamerale' | 'inverter' | 'batteriaAC' | 'spiEsterna'
  | 'planimetriaCatastale'
  | 'praticaEnea'
  | 'praticaDogane'
  | 'autodichiarazioneCliente';

export interface AttachmentInfo {
  id: number;
  fieldname: AttachmentType;
}

export interface Attachment extends AttachmentInfo {
  originalname: string;
  encoding: string;
  mimetype: string;
  destination: string;
  filename: string;
  path: string;
  size: number;
  createdAt: Date;
  LeadId: number;
}

export const AttachmentTypeOptions = {
  richiestaPreventivo: 'Richiesta preventivo',
  ordine: 'Ordine',
  preventivo: 'Preventivo',
  preventivoRevisionato: 'Preventivo revisionato',
  ordineRevisionato: 'Ordine revisionato',
  reportEcobonusCheck: 'Report fattibilità 110%',
  sopralluogoTecnico: 'Modulo per il sopralluogo / Lettera di incarico',
  esitoSopralluogoTecnico: 'Esito incarico tecnico',
  fotoSopralluogoTecnico: 'Foto del sopralluogo',
  extraSopralluogoTecnico: 'Preventivo con gli extra-costi',
  pratiche: 'Allegati progetto e pratiche',
  titoloAutorizzativo: 'Titolo autorizzativo',
  progettoElettrico: 'Progetto dell\' impianto elettrico',
  progettoTermico: 'Progetto dell\' impianto termico',
  computoMetrico: 'Computo metrico',
  dicoElettrica: 'DICO elettrica (dichiarazione di conformità)',
  dicoTermica: 'DICO termica (dichiarazione di conformità)',
  visura: 'Visura camerale',
  autotest: 'Autotest inverter/batteria/test report SPI ext',
  registrazioneCriter: 'Registrazione criter',
  fGas: 'Comunicazione F-Gas',
  confUrbCat: 'Relazione di conformità urbanistico catastale',
  modOutFattEner: 'Modulo output fattibilità energetica',
  apePre: 'APE Pre/APE Pre Convenzionale',
  apePostSimul: 'APE Post simulato in bozza',

  fotoImpianto: 'Foto impianto realizzato',
  allegatiInstallazione: 'Allegati per l\'installazione',
  fotoDG: 'Foto DG',
  fotoInverter: 'Foto etichette inverter',
  fotoBatteria: 'Foto etichette batteria',

  ddt: 'Documento di trasporto',
  verbaleAllaccio: 'Verbale di allaccio',
  endOfWork: 'Documentazione fine lavori',
  visuraCatastale: 'Visura catastale',
  planimetriaCatastale: 'Planimetria catastale',
  ultimaBollettaElettrica: 'Ultima bolletta energia elettrica',
  documentiIdentita: 'Carta d\'identità e tessera sanitaria',
  unifilare: 'Unifilare',
  dicoVisuraCamerale: 'DICO e Visura camerale',
  inverter: 'Inverter',
  batteriaAC: 'Batteria lato AC',
  spiEsterna: 'SPI esterna (se prevista)',
  altri: 'Altri allegati',
  praticaEnea: 'Pratica ENEA/GSE/Altro',
  praticaDogane: 'Dogane',
  autodichiarazioneCliente: 'Autodichiarazione cliente',
} as {
  [key: string]: string;
};

export type AttachmentActionType = 'add' | 'delete' | 'select' | 'unselect';

// Log

export interface LogEvent {
  title: string;
  details?: string;
  color: string;
  date: Date;
}

// Permissions

export type PermissionCode = string;

export interface Permission {
  id: number;
  codename: PermissionCode;
}

// Assignment Types

export interface AssignmentAssignee {
  assigneeId: number | null;
  assigneeName: string | null;
  status: 'todo' | 'done';
  assignedDate: Date | string | null;
}

export interface AssignmentType {
  id: string;
  label: string;
  ruleLabel?: string;
  childLabels?: Record<string, string>;
  icon: string;
  multipleAssignees: boolean;
  permissionShow: PermissionCode;
  permissionEdit: PermissionCode;
  userGroupIds?: number[];
  notesCustomValues?: Record<string, string>;
  notesLabels?: Record<string, string>;
  notesPermissions?: Record<string, { show: string; edit: string }>;
}

export interface AssignmentEntry {
  type: string;
  label: string;
  icon: string;
  dateTooltip: string;
  permissionShow: string;
  permissionEdit: string;
  multipleAssignees: boolean;
  assignees: AssignmentAssignee[];
  assigneeId: number | null;
  assigneeName: string | null;
  assigned: string | null;
  assignedDate: Date | null;
}

// Checklist

export interface Checklist {
  id: number;
  name: string;
  description: string;
  tasks: Task[];
}

//

export interface Group {
  id: number;
  name?: string;
  Permissions: Permission[];
  showInLeadUsers?: boolean;
  isActive?: boolean;
  networks: Network[];
}

export interface Tag {
  id: number;
  name: string | null;
  color: string | null;
  isActive: boolean;
  hidden: boolean;
  showInOperationList: boolean;
  showInConnectionList: boolean;
}

// Networks

export interface Network {
  id: number;
  name: string | null;
  shortname: string | null;
  logo: string | null;
  primaryColor: string | null;
  title: string | null;
}

export interface Category {
  id: number;
  name: string | null;
  color: string | null;
  isActive: boolean;
  hidden: boolean;
  showInOperationList: boolean;
  showInConnectionList: boolean;
}

export interface Credentials {
  username: string;
  password: string;
}

// Task

export type TaskName = 'C' | 'P' | 'O' | 'Cm' | 'S' | 'A' | 'V' | 'M' | 'I' | 'R';

export interface Task {
  id?: number;

  version: number;

  name: string;
  description: string | null;
  order: number;

  relationship: 'father' | 'child' | null;
  childType: LeadType | null;
  childCount: number | null;
  childName: string | null;

  status: 'error' | 'disabled' | 'completed' | null;
  text: string | null;

  completedAt: Date | null;
  errorAt: Date | null;
  disabledAt: Date | null;

  extraCosti: boolean;

  childLeadId: number | null;
  LeadId: number | null;
  ChecklistId: number | null;
  fatherLeadId: number | null;
}

export interface CustomValue {
  name: string;
  value?: string;
  integerValue?: number;
  booleanValue?: boolean;
  dateValue?: Date;
  userValueId: number | null;
}

// Leads

export type LeadStatus = 'draft' | 'new' | 'open' | 'pending'
  | 'resolved' | 'closed' | 'rejected' | 'cancelled'

export type LeadType = 'classica' | 'standard' | 'configuratore' | 'ordine' | 'richiesta'
  | 'installatore-figlia' | 'elettrica-figlia' | 'termica-figlia';

export type ShipmentStatus = 'not-planned' | 'partially-planned' | 'planned';

export type InstallationType = 'partial' | 'final';

export type InstallationDateStatus = 'confirmed' | 'not-confirmed';

export type PracticeAssigneesStatus = 'assigned' | 'not-assigned';

export type AssignmentStatusType = 'todo' | 'done' | 'na' | null;

export type InstallationStatus = 'todo' | 'done';

export type StepType = true | false | null;

export type ClosedReasonType = 'si iscrive nuovamente' | 'chiede di rimandare' | 'comprato da altri' | 'curioso' | 'no presupposti'
  | 'non conveniente' | 'non interessato' | 'non risponde' | 'altro';

export const ClosedReasonOptions = {
  'si iscrive nuovamente': 'LEAD si iscrive nuovamente - Inviata nuova lavorazione a SYLLA',
  'chiede di rimandare': 'Il cliente chiede di rimandare',
  'comprato da altri': 'Comprato da altri',
  curioso: 'Curioso / Chiede solo un preventivo',
  'no presupposti': 'Non ci sono i presupposti tecnici per la realizzazione',
  'non conveniente': 'Proposta troppo costosa / Trova l\'investimento non conveniente',
  'non interessato': 'Non più interessato all\'acquisto',
  'non risponde': 'Non risponde più alle chiamate',
  altro: 'Altro',
} as {
  [key: string]: string;
};

export type Iter = 'o' | 's' | 'bo' | 'bs' | 'b' | 'ps' | 'n';
export type IterType = 'new' | 'upgrade' | 'battery';

export type BoxStatusType = 'todo' | 'waiting' | 'done' | 'na';

export type BoxOutcomeType = 'todo' | 'fail' | 'success' | 'warning';

export type ConnectionStatusType = 'no-status' | 'suggested' | 'not-confirmed' | 'no-confirmation-required' | 'confirmed' | 'connected' | 'ko' | 'na';

export type ArchivedStatus = 'archived' | 'not-archived';

export type TaskStatus = 'error' | 'disabled' | 'completed' | null;

// Stato dell'assegnazione delle pratiche
export type PracticeAssignedType = 'todo' | 'done' | 'na' | null;

export interface OperationChildUser {
  id: number;
  name: string;
  isDisabled: boolean;
  isVirtual: boolean;
}

export interface OperationChild {
  id: number;
  code: string;
  status: LeadStatus;
  type: LeadType;
  title: string | null;

  categories: string;
  tags: string;

  allowedUsers?: string;

  taskVersions: {
    A: number;
    M: number;
    I: number;
    R: number;
  };

  // hasNotes: boolean;
  hasSharedNotes: boolean;
  hasPrivateNotes: boolean;
  otherAttachments: number;

  requester: OperationChildUser;
  owners: OperationChildUser[];

  flatTasks: string;
  firstTaskId: number | null;

  iter: Iter | null;

  siteInspectionDate: Date | null;
  siteInspectionResultNotes: string | null;
  hasExtraCosts: boolean;

  // hasP: boolean;
  // hasC: boolean;

  p: BoxStatusType | null;
  pHasNotes: boolean;
  c: BoxStatusType | null;
  cHasNotes: boolean;

  hasV: boolean;
  practiceAssigned: PracticeAssignedType | null;
  practiceAssignedDate: Date | null;

  practiceAssigneeName: string | null;
  practiceAssigneeId: number | null;
  practiceAssignees: AssignmentAssignee[];

  projectAssigned: AssignmentStatusType;
  projectAssignedDate: Date | null;
  projectAssigneeName: string | null;
  projectAssigneeId: number | null;
  projectAssignees: AssignmentAssignee[];

  eneaAssigned: AssignmentStatusType;
  eneaAssignedDate: Date | null;
  eneaAssigneeName: string | null;
  eneaAssigneeId: number | null;
  eneaAssignees: AssignmentAssignee[];

  eneaPracticeDate: Date | null;
  praticaEnea: string | null;

  doganeAssigned: AssignmentStatusType;
  doganeAssignedDate: Date | null;
  doganeAssigneeName: string | null;
  doganeAssigneeId: number | null;
  doganeAssignees: AssignmentAssignee[];

  installerAssigned: AssignmentStatusType;
  installerAssignedDate: Date | null;
  installerAssigneeName: string | null;
  installerAssigneeId: number | null;
  installerAssignees: AssignmentAssignee[];

  eCostsVerified: boolean;
  tCostsVerified: boolean;
  tConversionDone: boolean;
  tCeilingsVerified: boolean;
  tCertifierVerified: boolean;
  eVerificationsNotes: string | null;
  tVerificationsNotes: string | null;

  progettoElettricoNotes: string | null;
  progettoTermicoNotes: string | null;
  computoMetricoNotes: string | null;

  shipmentDestination: string | null;
  shipmentNotes: string | null;

  partialShipment: boolean;
  partialShipmentDate: Date | null;

  partialShipmentCompleted: boolean;
  shipmentCompleted: boolean;

  shipmentPicked: boolean;
  shipmentReady: boolean;
  deliveryDate: Date | null;

  subDefined: boolean;
  subSigned: boolean;
  subSent: boolean;
  subNotes: string | null;

  // Data di installazione specifica per la figlia
  partialInstallationDate: Date | null;
  partialInstallationDateMode: 'single' | 'week' | null;
  partialInstallationDateConfirm: boolean;
  partialInstallationCompleted: boolean;

  installationDate: Date | null;
  installationDateMode: 'single' | 'week' | null;
  installationDateConfirm: boolean;
  installationCompleted: boolean;

  installationNotes: string | null;

  hasAllegatiInstallazione?: boolean;

  // null = CustomValue mai impostato, distinto da false ("esplicitamente no").
  // Confrontare sempre con === true / === false, mai per verita' (issue #1168).
  internetConnectionTested: boolean | null;
  serviceConfirm: boolean | null;
  inverterConnected: boolean | null;
  commissioningNotes: string | null;

  missingFinishingsStatus: BoxStatusType | null;
  missingFinishingsNotes: string | null;

  connectionLastStep: string | null;
  connectionLastStepDate: Date | null;
  connectionLastStepDescription: string;

  egridConnectionDate: Date | null;
  egridConnectionTime: string | null;
  egridConnectionNotes: string | null;
  egridConnectionStatus: string | null;

  suggestedEgridConnectionDate1: Date | null;
  suggestedEgridConnectionTime1: string | null;
  suggestedEgridConnectionDate2: Date | null;
  suggestedEgridConnectionTime2: string | null;

  testingDate: Date | null;
  testingNotes: string | null;
  testingDateConfirm: boolean;

  docD: BoxStatusType | null;
  docV: BoxStatusType | null;
  docA: BoxStatusType | null;
  docC: BoxStatusType | null;
  docG: BoxStatusType | null;
  docF: BoxStatusType | null;

  docDHasNotes: boolean;
  docVHasNotes: boolean;
  docAHasNotes: boolean;
  docCHasNotes: boolean;
  docGHasNotes: boolean;
  docFHasNotes: boolean;

  docDDate: Date | null;

  sal: boolean;

  readyForSal1: boolean;
  readyForSal1Date: Date | null;

  readyForSal2: boolean;
  readyForSal2Date: Date | null;

  readyForFinalPayment: boolean;
  readyForFinalPaymentDate: Date | null;

  // null = CustomValue mai impostato (vedi i campi commissioning sopra).
  docsSentToPartner: boolean | null;
  docsSentToCustomer: boolean;

  gse: string | null;
  praticaDogane: string | null;
  doganeElettricoNotes: string | null;

  powerDetails1: string | null;
  powerDetails2: string | null;
  powerDetails3: string | null;
  powerDetails4: string | null;
  powerDetails5: string | null;
}

export interface OperationChildPool {
  [key: number]: OperationChild;
}

export interface Lead {
  id: number;
  code: string;
  status: LeadStatus;
  archived: boolean;
  type: LeadType;
  version: number;
  step1: StepType;
  step2: StepType;
  step3: StepType;
  step4: StepType;
  Tasks: Task[];
  CustomValues: CustomValue[];
  Attachments: Attachment[];

  step2Notes: string | null;
  step2SiteInspectionDate: Date | null;
  step3Descr: string | null;
  step3Quote: string | null;
  step3Notes: string | null;

  hasSystem?: boolean;
  idTustena?: string | null;

  ecCompletedAt: Date | null;
  ecResult: string | null;
  Quotations: Quotation[];
  checklists: Checklist[];
  network?: Network;

  requesterId: number;
  requester: User;
  owners: User[];

  isComplete: boolean;
  closedReason: ClosedReasonType | null;
  closedReasonLong: string;
  rejectedNotes: string | null;

  allowedUsers?: string;
  dirtyAllowedUsers?: boolean;
  flatOwners?: string;
  dirtyFlatOwners?: boolean;
  flatCategories?: string;
  dirtyFlatCategories?: boolean;
  flatTags?: string;
  dirtyFlatTags?: boolean;
  flatTasks?: string;
  dirtyFlatTasks?: boolean;
  _accessViaConnection?: boolean;

  // Dati mostrati
  tipoCliente: 'person' | 'business';
  nome: null | string;
  cognome: null | string;
  ragioneSociale: null | string;
  indirizzo: null | string;
  toponimo: null | string;
  civico: null | string;
  interno: null | string;
  cap: null | string;
  citta: null | string;
  partitaIva: null | string;
  codiceFiscaleAzienda: null | string;
  codiceFiscale: null | string;
  telefono: null | string;
  altroTelefono: null | string;
  pec: null | string;
  email: null | string;
  provincia: null | string;

  // Contatto
  // contactFirstName: null | string;
  // contactLastName: null | string;
  // contactCompany: null | string;

  // Fatturazione
  hasBilling: boolean;
  billingType: 'person' | 'business';
  billingFirstName: null | string;
  billingLastName: null | string;
  billingCompany: null | string;

  // Bolletta
  hasInstallation: boolean;
  installationType: 'person' | 'business';
  installationFirstName: null | string;
  installationLastName: null | string;
  installationCompany: null | string;
  installationLocation: null | string;
  installationProvince: null | string;

  opNumber: null | string;
  opType: null | string;

  payments: number;

  partialShipment: boolean;
  shipmentPicked: boolean;
  shipmentReady: boolean;

  sal: boolean;
  readyForSal1: boolean;
  readyForSal1Date: Date | null;
  readyForSal2: boolean;
  readyForSal2Date: Date | null;
  readyForFinalPayment: boolean;
  readyForFinalPaymentDate: Date | null;

  notes: string | null;
  notesUpdatedAt: Date | null;
  privateNotes: string | null;
  privateNotesUpdatetAt: Date | null;

  titoloAutorizzativo: BoxStatusType | null;
  titoloAutorizzativoDate: Date | null;

  endOfWork: BoxStatusType | null;
  endOfWorkDate: Date | null;

  testingOutcome: BoxOutcomeType | null;
}

export interface ChildLeads {
  [key: number]: Lead;
}

export interface ProjectsPool {
  [key: number]: Lead;
}

// Memorizza alcune informazioni di base del progetto
export interface ProjectInfo {
  id: number;
  status: LeadStatus;
  allowedUsers: string;
}

export interface ProjectsInfoPool {
  [key: number]: ProjectInfo;
}

export interface OperationsPool {
  [key: number]: Operation;
}

export type ProjectsList = Lead[];

export type OperationsList = Operation[];

export type LeadUpdateType = 'customer' | 'details' | 'payments' | 'supply' | 'owners'
  | 'sharedNotes' | 'privateNotes' | 'opNotes' | 'practiceNotes' | 'task' | 'taskC' | 'attachments';

export interface SocketLeadUpdatedData {
  id: number;
  action: 'created' | 'updated' | 'deleted';
}

export interface SocketOperationUpdatedData {
  id: number;
  action: 'created' | 'updated' | 'deleted';
}

export interface LeadUpdatedData {
  // Id della Lead, Operation e Connection da aggiornare
  id: number;
  // Tipo di aggiornamento (creazione, modifica, cancellazione)
  action: 'created' | 'updated' | 'deleted';
  // Elenco degli attributi modificati
  attributes?: string[];
}

export interface ZipProgressData {
  percent: number;
  done: boolean;
  error?: boolean;
  message?: string;
}

export interface Quotation {
  id: number;
  original: string;
  complete: boolean;
}

export type QuotationProperty = 'fabbisognoAnnuo' | 'potenzaDaConsumi' | 'potenzaDaSpazioPerformance'
  | 'potenzaDaSpazioTop' | 'producibilitaAnnuaPerformance' | 'producibilitaAnnuaTop' | 'faldePerformance'
  | 'faldeTop' | null;

export type StepNames = 'step1' | 'step2' | 'step3' | 'step4';

export interface ChildTasks {
  [key: number]: Task[];
}

export interface ContactDetails {
  // Contatto
  type: 'person' | 'business';
  company: null | string;
  VAT: null | string;
  companyTaxCode: null | string;
  firstName: null | string;
  lastName: null | string;
  taxCode: null | string;
  phone1: null | string;
  phone2: null | string;
  PEC: null | string;
  email: null | string;
  toponym: null | string;
  street: null | string;
  houseNumber: null | string;
  postalCode: null | string;
  location: null | string;
  province: null | string;

  // Fatturazione
  hasBilling: boolean;
  billingType: 'person' | 'business';
  billingCompany: null | string;
  billingVAT: null | string;
  billingCompanyTaxCode: null | string;
  billingFirstName: null | string;
  billingLastName: null | string;
  billingTaxCode: null | string;
  billingPhone1: null | string;
  billingPhone2: null | string;
  billingPEC: null | string;
  billingEmail: null | string;
  billingToponym: null | string;
  billingStreet: null | string;
  billingHouseNumber: null | string;
  billingPostalCode: null | string;
  billingLocation: null | string;
  billingProvince: null | string;

  // Bolletta
  hasInstallation: boolean;
  installationType: 'person' | 'business';
  installationCompany: null | string;
  installationVAT: null | string;
  installationCompanyTaxCode: null | string;
  installationFirstName: null | string;
  installationLastName: null | string;
  installationTaxCode: null | string;
  installationPhone1: null | string;
  installationPhone2: null | string;
  installationPEC: null | string;
  installationEmail: null | string;
  installationToponym: null | string;
  installationStreet: null | string;
  installationHouseNumber: null | string;
  installationPostalCode: null | string;
  installationLocation: null | string;
  installationProvince: null | string;
}

export interface DataTableHeaderOptions {
  text: string;
  value: string;
  align?: 'start' | 'center' | 'end';
  sortable?: boolean;
  filterable?: boolean;
  groupable?: boolean;
  divider?: boolean;
  class?: string | string[];
  cellClass?: string | string[];
  width?: string | number;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
}

export type WarehouseType = 'yes' | 'partial' | 'no' | 'null';

export type ReadyForFinalPaymentFilter = 'ready' | 'not-ready';

export type ShipmentCompletedFilter = 'completed' | 'not-completed';

export type InternetConnectionFilter = 'tested' | 'not-tested';

export type ServiceConfirmFilter = 'confirmed' | 'not-confirmed';

export type InverterConnectedFilter = 'connected' | 'not-connected';

export type TestingDateConfirmFilter = 'confirmed' | 'not-confirmed';

export type DocsSentToPartnerFilter = 'sent' | 'not-sent';

export interface OperationsFilters {
  search?: string;
  requester: number | null;
  owner: number[] | null;
  ownerLogic: LogicType;
  childType: LeadType[];
  projectStatus: BoxStatusType[];
  warehouse: (WarehouseType | 'null')[];
  shipmentStatus: ShipmentStatus[];

  partialInstallationDateStatus: InstallationDateStatus | null;
  partialInstallationStatus: InstallationStatus | null;
  installationDateStatus: InstallationDateStatus | null;
  installationStatus: InstallationStatus | null;

  dicoStatus: BoxStatusType[];

  readyForFinalPayment: ReadyForFinalPaymentFilter | null;
  shipmentCompleted: ShipmentCompletedFilter | null;
  internetConnection: InternetConnectionFilter | null;
  serviceConfirm: ServiceConfirmFilter | null;
  inverterConnected: InverterConnectedFilter | null;
  testingDateConfirm: TestingDateConfirmFilter | null;
  docsSentToPartner: DocsSentToPartnerFilter | null;

  testingOutcome: (BoxOutcomeType | 'nodate')[];
  egridConnectionStatus: ConnectionStatusType[];
  archivedStatus: ArchivedStatus[];
  childStatus: LeadStatus[];
  fatherStatus: LeadStatus[];
  taskO: string[];
  taskCm: string[];
  opType: string[];
  payments: number[];
  missingFinishings?: BoxStatusType[];
  sortBy: string[];
  sortDesc: boolean[];
  dates?: {
    value: string | null;
    begin: Date | null | false;
    end: Date | null | false;
  };
  categories: number[];
  categoriesLogic: LogicType;
  categoriesNegated?: (number | string)[];
  tags: number[];
  tagsLogic: LogicType;
  tagsNegated?: (number | string)[];
  provinces: string[];
  provincesLogic: LogicType;
  provincesNegated?: (number | string)[];
  ownerNegated?: (number | string)[];

  practiceAssignees?: (number | null)[];
  practiceAssigneesLogic?: LogicType;
  practiceAssigneesStatus?: PracticeAssigneesStatus | null;
  practiceAssigneesNegated?: (number | string)[];
  projectAssignees?: (number | null)[];
  projectAssigneesLogic?: LogicType;
  projectAssigneesStatus?: PracticeAssigneesStatus | null;
  projectAssigneesNegated?: (number | string)[];
  eneaAssignees?: (number | null)[];
  eneaAssigneesLogic?: LogicType;
  eneaAssigneesStatus?: PracticeAssigneesStatus | null;
  eneaAssigneesNegated?: (number | string)[];
  doganeAssignees?: (number | null)[];
  doganeAssigneesLogic?: LogicType;
  doganeAssigneesStatus?: PracticeAssigneesStatus | null;
  doganeAssigneesNegated?: (number | string)[];
  installerAssignees?: (number | null)[];
  installerAssigneesLogic?: LogicType;
  installerAssigneesStatus?: PracticeAssigneesStatus | null;
  installerAssigneesNegated?: (number | string)[];

  searchItems: string[];
  searchValue: string | null;
  searchLogic?: 'AND' | 'OR';
  searchExclude?: string | null;
}

// User

export interface User {
  id: number;
  name: string | null;
  username?: string;
  groups: Group[];

  isSuperUser: boolean;
  isDisabled: boolean;
  isVirtual: boolean;

  Permissions?: Permission[];

  // Le impostazioni dell'utente sono salvate come oggetto JSON serializzato
  settings?: string;
  // Le impostazioni dell'utente (es. filtri, ordinamenti) sono salvate nel DB
  permanentSettings?: boolean;

  // Token di accesso ai calendari
  iCalToken: string | null;
}

export interface UserSettings {
  // leadsFilters?: LeadsFilters;
  operationsFilters?: OperationsFilters;
  connectionsFilters?: ConnectionsFilters;
  // Ultima vista usata fra elenco, commesse e connessioni: il portale riapre li'.
  lastView?: string;
}

// ConfirmDialog

export interface ConfirmDialogOptions {
  title: string;
  text: string | string[];
  question: string;
  yesText: string;
  noText: string;

  // Label di un eventuale campo di testo da compilare
  inputLabel?: string;
  // Valore di default del campo di testo
  inputValue?: string;
  // Tipo di campo di testo
  inputType?: 'textarea'; // TODO: | 'text' | 'number' | 'email' | 'password';
  // Placeholder del campo di testo
  inputPlaceholder?: string;
  // Il valore è obbligatorio
  inputRequired?: boolean;
}

// Commesse

export interface OperationInfo {
  id: number;
  status: LeadStatus;

  archived: boolean;

  allowedUsers: string;
  fatherAllowedUsers?: string;

  code: string;

  opNumber: null | string;
  opType: null | string;
  hasOpNotes: boolean;

  categories: string;
  tags: string;

  hasInstallation: boolean;

  // Contatto
  customerType: 'person' | 'business';
  company: null | string;
  firstName: null | string;
  lastName: null | string;

  // Fatturazione
  hasBilling: boolean;
  billingCompany: null | string;
  billingFirstName: null | string;
  billingLastName: null | string;
  billingType: 'person' | 'business';

  // Bolletta
  installationType: 'person' | 'business';
  installationCompany: null | string;
  installationFirstName: null | string;
  installationLastName: null | string;

  installationProvince?: string;
  hasSupplyNotes: boolean;
  supplyText: null | string;
  supplyLabel: null | string;

  hasPracticeNotes: boolean;

  contactDetails: string;

  eneaPracticeDate: Date | null;
  praticaEnea: string | null;

  // Totale contrattuale
  totalContractValue: string | null;
  totalContractValueNotes: string | null;
}

export interface Operation extends OperationInfo {
  type: LeadType;

  invoiceDiscount: null | 'yes' | 'no';
  loan: null | 'yes' | 'no';

  payments: number;
  hasPaymentsNotes: boolean;
  latestPaymentDate: Date | null;

  hasPaymentsDates: boolean;

  // Date pagamenti
  firstPaymentDate: Date | null;
  secondPaymentDate: Date | null;
  partialInstallationPaymentDate: Date | null;
  finalPaymentDate: Date | null;

  // Riferimenti fattura
  firstPaymentInvoiceRef: string | null;
  firstPaymentInvoiceDate: Date | null;
  secondPaymentInvoiceRef: string | null;
  secondPaymentInvoiceDate: Date | null;
  partialInstallationPaymentInvoiceRef: string | null;
  partialInstallationPaymentInvoiceDate: Date | null;
  finalPaymentInvoiceRef: string | null;
  finalPaymentInvoiceDate: Date | null;

  hasTargetDateNotes: boolean;
  targetDate: Date | null;
  targetReminder: boolean;

  orderConfirmationDate: Date | null;

  firstPmClientContactDate: Date | null;

  children: OperationChildPool;
  childrenIds: string;

  childrenTypes: string;
  childrenData: string;

  childrenOwnersIds: string;

  eInstallationDate: Date | null;
  tInstallationDate: Date | null;

  eInstallerAssignedDate?: Date | null;
  eInstallerAssigneeId?: number | null;
  tInstallerAssignedDate?: Date | null;
  tInstallerAssigneeId?: number | null;

  ePlanDate: Date | null;
  ePlanDoneDate: Date | null;
  tPlanDate: Date | null;
  ePlanDateViewMode: string;
  tPlanDateViewMode: string;

  eWarehouse: WarehouseType | null;
  tWarehouse: WarehouseType | null;

  eMaterialsTargetDate: Date | null;
  tMaterialsTargetDate: Date | null;
  eMaterialsTargetDateViewMode: string;
  tMaterialsTargetDateViewMode: string;

  readyForFinalPayment: boolean;

  titoloAutorizzativo: BoxStatusType | null;
  hasTitoloAutorizzativoNotes: boolean;

  connectionDate: Date | null;
  connectionActiveDate: Date | null;

  endOfWork: BoxStatusType | null;
  hasEndOfWorkNotes: boolean;

  testingOutcome: BoxOutcomeType | null;

  commissioningStatus: string | null;
  commissioningDate: Date | null;

  suggestedEgridConnectionDate1: Date | null;
  suggestedEgridConnectionDate2: Date | null;

  connectionLastStep: string;
  connectionLastStepDate: Date | null;
}

// Connessioni

export interface Connection extends OperationInfo {
  practiceAssigneeName: string | null; // Il nome dell'assegnatario della pratica
  practiceAssigned: PracticeAssignedType | null; // La conferma dell'assegnazione della pratica
  practiceAssignedDate: Date | null; // La data di conferma dell'assegnazione della pratica
  practiceAssigneeId: number | null; // L'id dell'assegnatario della pratica (foreign key)
  practiceAssignees: AssignmentAssignee[]; // Multi-assegnatario pratiche

  projectAssigneeName: string | null; // Il nome dell'assegnatario del progetto
  projectAssigned: AssignmentStatusType; // La conferma dell'assegnazione del progetto
  projectAssignedDate: Date | null; // La data di conferma dell'assegnazione del progetto
  projectAssigneeId: number | null; // L'id dell'assegnatario del progetto (foreign key)
  projectAssignees: AssignmentAssignee[]; // Multi-assegnatario progetto

  eneaAssigneeName: string | null; // Il nome dell'assegnatario ENEA/GSE/Altro
  eneaAssigned: AssignmentStatusType; // La conferma dell'assegnazione ENEA/GSE/Altro
  eneaAssignedDate: Date | null; // La data di conferma dell'assegnazione ENEA/GSE/Altro
  eneaAssigneeId: number | null; // L'id dell'assegnatario ENEA/GSE/Altro (foreign key)
  eneaAssignees: AssignmentAssignee[]; // Multi-assegnatario ENEA/GSE/Altro

  doganeAssigneeName: string | null; // Il nome dell'assegnatario Dogane
  doganeAssigned: AssignmentStatusType; // La conferma dell'assegnazione Dogane
  doganeAssignedDate: Date | null; // La data di conferma dell'assegnazione Dogane
  doganeAssigneeId: number | null; // L'id dell'assegnatario Dogane (foreign key)
  doganeAssignees: AssignmentAssignee[]; // Multi-assegnatario Dogane

  installerAssigneeName: string | null; // Il nome dell'assegnatario Installatore
  installerAssigned: AssignmentStatusType; // La conferma dell'assegnazione Installatore
  installerAssignedDate: Date | null; // La data di conferma dell'assegnazione Installatore
  installerAssigneeId: number | null; // L'id dell'assegnatario Installatore (foreign key)
  installerAssignees: AssignmentAssignee[]; // Multi-assegnatario Installatore

  praticaDogane: string | null;
  doganeElettricoNotes: string | null;

  practiceNumber: string | null; // Il numero della pratica
  practiceSendingDate: Date | null; // La data di invio della pratica
  practiceSendingAnagraficaDelay?: boolean; // Ritardo per disallineamento anagrafica (denormalizzato)

  mup1RequestDate?: Date;
  mup1: number;
  mup1CompletedDate: Date | null;

  // mup2RequestDate?: Date;
  mup2: number;
  mup2CompletedDate: Date | null;

  enea: number;
  eneaCompletedDate: Date | null;

  endOfWorksDate?: Date;
  rdeSendingDate?: Date;

  iter: Iter | null;
  iterType: IterType | null;
  iterAcceptance: boolean; // L'accettazione dell'iter da parte dell'assegnatario
  iterAcceptanceDate: Date | null; // La data di accettazione dell'iter da parte dell'assegnatario

  iterConfirmationDate: Date | null;
  iterConfirmationPendingDate: Date | null;
  iterConfirmation: string | null;

  cancelledConnections: number | 0; // Il numero di connessioni archiviate

  egridConnectionStatus: string | null;
  suggestedEgridConnectionDate1: Date | null;
  suggestedEgridConnectionTime1: string | null;
  suggestedEgridConnectionDate2: Date | null;
  suggestedEgridConnectionTime2: string | null;
  egridConnectionDate: Date | null;
  egridConnectionTime: string | null;
  egridConnectionActiveDate: Date | null;
  egridConnectionNotes: string | null;
  verbaleAllaccio: string | null;

  partialInstallationDate: string | null;
  partialInstallationDateMode: 'single' | 'week' | null;
  installationDate: string | null;
  installationDateMode: 'single' | 'week' | null;
  installationTaskStatus: TaskStatus;
  installationDateConfirm: boolean;
  installationCompleted: boolean;
  partialInstallationCompleted: boolean;
  partialInstallationDateConfirm: boolean;
  installationNotes: string | null;

  planTaskStatus: TaskStatus;
  planStatus: BoxStatusType | null;
  hasPlanNotes: boolean;
  powerDetails1: string | null;
  powerDetails2: string | null;
  powerDetails3: string | null;
  powerDetails4: string | null;
  powerDetails5: string | null;

  titoloAutorizzativoTaskStatus: TaskStatus;
  titoloAutorizzativoStatus: BoxStatusType | null;
  hasTitoloAutorizzativoNotes: boolean;
}

export interface ConnectionsPool {
  [key: number]: Connection;
}

export type ConnectionsList = Connection[];

export interface ConnectionsFilters {
  status?: LeadStatus[];
  childStatus?: LeadStatus[];
  search?: string;
  iter?: Iter;
  practiceAssignees?: (number | null)[];
  practiceAssigneesLogic?: LogicType;
  practiceAssigneesStatus?: PracticeAssigneesStatus | null;
  taskCm?: string[];
  categories?: number[];
  categoriesLogic?: LogicType;
  categoriesNegated?: (number | string)[];
  tags?: number[];
  tagsLogic?: LogicType;
  tagsNegated?: (number | string)[];
  provinces?: string[];
  provincesLogic?: LogicType;
  provincesNegated?: (number | string)[];
  practiceAssigneesNegated?: (number | string)[];
  projectAssignees?: (number | null)[];
  projectAssigneesLogic?: LogicType;
  projectAssigneesStatus?: PracticeAssigneesStatus | null;
  projectAssigneesNegated?: (number | string)[];
  eneaAssignees?: (number | null)[];
  eneaAssigneesLogic?: LogicType;
  eneaAssigneesStatus?: PracticeAssigneesStatus | null;
  eneaAssigneesNegated?: (number | string)[];
  doganeAssignees?: (number | null)[];
  doganeAssigneesLogic?: LogicType;
  doganeAssigneesStatus?: PracticeAssigneesStatus | null;
  doganeAssigneesNegated?: (number | string)[];
  installerAssignees?: (number | null)[];
  installerAssigneesLogic?: LogicType;
  installerAssigneesStatus?: PracticeAssigneesStatus | null;
  installerAssigneesNegated?: (number | string)[];
  egridConnectionStatus?: ConnectionStatusType[];
  installationStatus?: InstallationStatus[];
  projectStatus?: BoxStatusType[];
  sortBy?: string[];
  sortDesc?: boolean[];
  dates?: {
    value: string | null;
    begin: Date | null | false;
    end: Date | null | false;
  };
  // Filtri per la ricerca testuale (utilizzato per la ricerca sulla fornitura)
  searchValue?: string;
  searchItems?: string[];
  searchLogic?: 'AND' | 'OR';
  searchExclude?: string | null;
  // Filtro per la documentazione fine lavori inviata all'assegnatario
  docsSentToPartner?: DocsSentToPartnerFilter | null;
}

export type ProgressType = 'mup1' | 'mup2' | 'enea';

export interface ProgressDetails {
  [key: string]: BoxStatusType | {
    // Il valore utilizzato per colorare il v-chip (utilizzando il formato di BoxStatusType)
    status: BoxStatusType;
    // Il testo scritto all'interno del v-chip che mostra lo status
    statusLabel: string | boolean;
    // Il testo descrittivo mostrato a destra
    label: string;
  };
}

// CancelledConnection

export interface CancelledConnection {
  id: number;
  connectionId: number;
  reason: string | null;
  cancelDate: Date | null;
  snapshot: string;
}

export interface CancelledConnectionDetails {
  [key: string]: BoxStatusType | {
    // Il valore utilizzato per colorare il v-chip (utilizzando il formato di BoxStatusType)
    status: BoxStatusType;
    // Il testo scritto all'interno del v-chip che mostra lo status
    statusLabel: string | boolean;
    // Il testo descrittivo mostrato a destra
    label: string;
  };
}

// CalendarEvent

export type CalendarEventType = 'commissioning' | 'installation';

export interface CalendarEvent {
  // Data, orario di inizio e fine
  date: Date;
  startTime: string | null;
  endTime: string | null;

  type: CalendarEventType;

  // Dettagli aggiuntivi
  details: {
    [key: string]: string | number | boolean | OperationChildUser[] | null;
  };
}

export interface CalendarUrlOption {
  text: string;
  url: string;
}

// Filter Presets
export interface FilterPreset<T> {
  name: string;
  filters: T;
}

export type OperationsFilterPreset = FilterPreset<OperationsFilters>;
export type ConnectionsFilterPreset = FilterPreset<ConnectionsFilters>;

// Rule Tester
export interface RuleTestConditionCustomValue {
  type: 'text' | 'status' | 'task' | 'user' | 'group' | 'category' | 'tag' | 'template' | 'attachmentType' | 'checklist' | 'date' | 'boolean' | 'integer' | 'float' | 'activityStatus' | 'egridConnectionStatus' | 'commissioningStatus' | 'assignmentType';
  value?: string | string[];
  dateValue?: Date | string;
  booleanValue?: boolean;
  integerValue?: number;
  floatValue?: number;
  userValue?: { id: number; name: string; isSuperUser?: boolean; isVirtual?: boolean; groups?: Array<{ id: number; name: string }> };
  groupValue?: { id: number; name: string };
  categoryValue?: { id: number; name: string };
  tagValue?: { id: number; name: string };
  templateValue?: { id: number; name: string };
  checklistValue?: { id: number; name: string };
  multiple?: boolean;
}

export interface RuleTestCondition {
  codename: string;
  name: string;
  result: boolean;
  debugMessage?: string;
  customValues?: RuleTestConditionCustomValue[];
}

export interface RuleTestResult {
  id: number;
  name: string;
  isActive: boolean;
  when: 'all' | 'one';
  triggered: boolean;
  conditions: RuleTestCondition[];
}

export interface RuleTestResponse {
  leadId: number;
  eventCodename: 'time.everyday';
  simulatedDate: string; // ISO date string (YYYY-MM-DD)
  rules: RuleTestResult[];
}

// Rule Management (frontend migration)

export interface RuleEvent {
  codename: string;
  name: string;
}

export interface RuleCustomValue {
  name: string;
  type: 'text' | 'status' | 'task' | 'user' | 'group' | 'category' | 'tag' | 'template'
    | 'attachmentType' | 'checklist' | 'date' | 'boolean' | 'integer' | 'float'
    | 'activityStatus' | 'egridConnectionStatus' | 'commissioningStatus' | 'assignmentType';
  // Hint dichiarato nella definition (condition/action) per restringere le
  // opzioni mostrate in UI. Es. filter:'activityStatus' su un CV di tipo
  // 'attachmentType' fa mostrare solo i tipi con stato attività.
  filter?: 'activityStatus';
  // Dichiarato nella definition: il valore puo' restare vuoto (es. gli elenchi
  // "Eccetto..." di notify.email.new_owners), e non tiene Salva disabilitato.
  optional?: boolean;
  label?: string;
  help?: string;
  value?: any;
  dateValue?: Date | string | null;
  booleanValue?: boolean | null;
  integerValue?: number | null;
  floatValue?: number | null;
  userValue?: any;
  groupValue?: any;
  categoryValue?: { id: number; name: string } | null;
  tagValue?: { id: number; name: string } | null;
  templateValue?: { id: number; name: string } | null;
  checklistValue?: { id: number; name: string } | null;
  multiple?: boolean;
}

export interface RuleConditionDefinition {
  codename: string;
  name: string;
  customValues: RuleCustomValue[];
  // Valida nelle regole che la usano, ma non proposta fra quelle da aggiungere
  obsolete?: boolean;
}

export interface RuleActionDefinition {
  codename: string;
  name: string;
  customValues: RuleCustomValue[];
  obsolete?: boolean;
}

export interface RuleCondition {
  codename: string;
  name: string;
  customValues: RuleCustomValue[];
}

export interface RuleConditionBlock {
  block: 'and' | 'or' | 'not';
  conditions: RuleConditionItem[];
}

export type RuleConditionItem = RuleCondition | RuleConditionBlock;

export interface RuleAction {
  codename: string;
  name: string;
  order: number;
  customValues: RuleCustomValue[];
}

export interface Rule {
  id: number;
  name: string;
  order: number;
  isActive: boolean;
  when: 'all' | 'one';
  event?: RuleEvent;
  conditions: RuleCondition[];
  actions: RuleAction[];
  // Item in errore negli ultimi 7 giorni (GET /api/v1/rules)
  recentErrors?: number;
}

export interface RuleFormData {
  name: string;
  order: number;
  event: RuleEvent | null;
  conditions: RuleConditionItem[];
  when: 'all' | 'one';
  actions: RuleAction[];
}

// Voce dell'archivio delle regole del vecchio portale. `payload` c'e' solo
// nel dettaglio e ha la forma di GET /api/rule/:id, con i nomi delle
// entita' citate; `changes` elenca le sostituzioni email fatte all'archiviazione.
export interface RuleArchiveEntry {
  id: number;
  sourceId: number;
  name: string;
  wasActive: boolean;
  eventCodename: string | null;
  flagged: boolean;
  clientNote: string | null;
  searchText: string;
  payload?: Rule & { conditions: any[] };
  changes?: string[];
}

// Log delle esecuzioni delle regole (GET /api/v1/rules/executions)
export type RuleExecutionOutcome = 'triggered' | 'not_triggered' | 'error';

export interface RuleLogCondition {
  type: 'condition';
  codename: string;
  result: boolean | null;
  error?: boolean;
  customValues: RuleCustomValue[];
}

export interface RuleLogBlock {
  type: 'block';
  operator: 'and' | 'or' | 'not';
  result: boolean | null;
  children: RuleLogNode[];
}

export type RuleLogNode = RuleLogCondition | RuleLogBlock;

export interface RuleLogAction {
  codename: string;
  customValues: RuleCustomValue[];
  status: 'ok' | 'skipped' | 'error';
  reason: string | null;
  error: string | null;
  email: boolean;
}

export interface RuleEmailDelivery {
  id: number;
  actionIndex: number;
  recipient: string | null;
  userId: number | null;
  userName: string | null;
  status: 'queued' | 'sent' | 'failed' | 'log_only' | 'excluded';
  reason: string | null;
  error: string | null;
  providerResponse: string | null;
  sentAt: string | null;
  createdAt: string;
}

export interface RuleRunInfo {
  id: number;
  status: 'completed' | 'error' | 'timeout';
  userId: number | null;
  userName: string | null;
  queuedAt: string | null;
  startedAt: string;
  durationMs: number | null;
}

export interface RuleExecution {
  id: number;
  RuleRunId: number;
  RuleId: number;
  ruleName: string;
  ruleWhen: 'all' | 'one' | null;
  LeadId: number;
  leadCode: string;
  leadName: string | null;
  eventCodename: string;
  outcome: RuleExecutionOutcome;
  conditions: RuleLogNode[];
  conditionsTotal: number | null;
  error: string | null;
  createdAt: string;
  run: RuleRunInfo | null;
  // Solo nel dettaglio (GET /api/v1/rules/executions/:id)
  actions?: RuleLogAction[];
  errorStack?: string | null;
  deliveries?: RuleEmailDelivery[];
}

export interface RuleExecutionList {
  total: number;
  items: RuleExecution[];
}

export interface RuleRunAnomaly {
  id: number;
  eventCodename: string;
  LeadId: number | null;
  leadCode: string | null;
  status: 'error' | 'timeout';
  error: string | null;
  errorStack: string | null;
  queuedAt: string | null;
  startedAt: string;
  userName: string | null;
}

export interface RuleNightSummary {
  day: string;
  batches: number;
  leadsEvaluated: number;
  rulesTriggered: number;
  errors: number;
}

export interface RuleRunsSummary {
  anomalies: RuleRunAnomaly[];
  nights: RuleNightSummary[];
}
